'use client';
import { createThreadMetadata, socialInfoToStats, } from '#pplx/frontend/apps/ask/thread-data/rwTokenUtils.js';
import { createContext, useContext } from 'react';
export const createArticleMetadata = (sections) => {
    if (sections[0]?.article_info) {
        return {
            title: sections[0].article_info.title || '',
            summary: sections[0].article_info.summary || '',
            suggested_sections: sections[0].article_info.suggested_sections || [],
            audience: sections[0].article_info.audience || 'anyone',
            read_time: sections[0].article_info.read_time,
            emphasize_sources: sections[0].article_info.emphasize_sources ?? false,
            num_sections: sections.length,
        };
    }
    else {
        return null;
    }
};
const initial = {
    isBlocksApi: false,
    article: [],
    heroSection: undefined,
    isLoading: false,
    isPublished: false,
    isOrgInternal: false,
    inFlight: false,
    inFlightLatest: false,
    currentlyStreamingSection: undefined,
    socialStats: {
        forkCount: 0,
        likeCount: 0,
        userLikes: false,
    },
    threadMetadata: {
        rwToken: undefined,
        contextUUID: undefined,
        frontendContextUUID: undefined,
        title: undefined,
        first_query: undefined,
        focus: undefined,
        author_id: undefined,
        author_username: undefined,
        author_image: undefined,
        parent_info: undefined,
        mode: undefined,
        personalized: false,
        collection: undefined,
        thread_access: 0,
        thread_url_slug: undefined,
        updated_datetime: undefined,
        expiry_time: undefined,
        privacy_state: 'NONE',
    },
    articleMetadata: {
        title: '',
        summary: '',
        suggested_sections: [],
        audience: 'anyone',
        read_time: 0,
        emphasize_sources: false,
        num_sections: 0,
    },
    articleMedia: [],
    articleWebResults: [],
    relatedPages: [],
    articleLocalState: {
        isEditModeEnabled: false,
        setEditModeEnabled: () => void 0,
        isCreating: false,
        setIsCreating: () => void 0,
        isTitleVisible: true,
        setTitleVisible: () => void 0,
        clickedImage: null,
        setClickedImage: () => void 0,
        isRewritingSection: false,
        setRewritingSection: () => void 0,
    },
    refetch: () => void 0,
};
export const ArticleResultsContext = createContext(initial);
ArticleResultsContext.displayName = 'ArticleResultsContext';
export const useArticleResults = () => {
    const ctx = useContext(ArticleResultsContext);
    if (!ctx)
        throw new Error('useArticleResults must be used within ArticleResultsContext');
    return ctx;
};
//# sourceMappingURL=ArticleResultsProviderShared.js.map